export const LINK_STYLES = {
  color: 'inherit',
  cursor: 'pointer',
  display: 'inline',
  lineHeight: 'inherit',
  p: 0,
  verticalAlign: 'baseline',
} as const
